import { useToken, useWindowDimensions } from 'app/hooks'
import React from 'react'
import DerivativesFormBtns from './DerivativesFormBtns'
import OrderPriceInput from './OrderPriceInput'
import OrderValueInput from './OrderValueInput'

import { useOrderStore } from '../../../../../../hooks/trade/orderStore'
import SpaceAva from './SpaceAva'
import TabBar from './TabBar'
import { DerivativesBodyWrapper } from './styles'
import OrderValueQty from './OrderValueInput/OrderValueQty'

const DerivativesBody = ({ isMobile = false }) => {
	const { data: orderStore } = useOrderStore()
	const { width, outerWidth } = useWindowDimensions()
	const [tab, setTab] = React.useState(orderStore?.limit_market || 'L')

	const { data: token } = useToken()


	return (
		<DerivativesBodyWrapper
			style={{
				zoom: 1 / (outerWidth / width),
			}}>
			<SpaceAva isMobile={isMobile} />

			<TabBar tab={tab} setTab={setTab} />
			<OrderValueQty />
			
			{tab != 'M' && <OrderPriceInput />}
			<OrderValueInput />
			{token ? (
				<DerivativesFormBtns
					isMobile={isMobile}
					ismit={tab == 'MIT'}
					tab={tab}
					zoom={1 / (outerWidth / width)}
				/>
			) : (
				<></>
			)}
		</DerivativesBodyWrapper>
	)
}

export default React.memo(DerivativesBody)
